module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-462.ace44ff.woff2";